export type DiscountType = "fixed" | "percentage";

export interface PosLinePricingInput {
  unitPrice: number;
  quantity: number;
  discount?: number | null;
  discountType?: string | null;
}

export const normalizeDiscountType = (
  value?: string | null
): DiscountType => (value === "percentage" ? "percentage" : "fixed");

export const calculateLineBaseTotal = (
  unitPrice: number,
  quantity: number
): number => Math.max(0, Number(unitPrice || 0) * Math.max(0, Number(quantity || 0)));

export const calculateLineDiscountAmount = (
  input: PosLinePricingInput
): number => {
  const baseTotal = calculateLineBaseTotal(input.unitPrice, input.quantity);
  const rawDiscount = Math.max(0, Number(input.discount || 0));

  const discountAmount =
    normalizeDiscountType(input.discountType) === "percentage"
      ? (baseTotal * rawDiscount) / 100
      : rawDiscount;

  return Math.min(baseTotal, discountAmount);
};

export const calculateLineTotal = (input: PosLinePricingInput): number =>
  Math.max(
    0,
    calculateLineBaseTotal(input.unitPrice, input.quantity) -
      calculateLineDiscountAmount(input)
  );
